import {loginErrorMessage} from './loginErrorMessage';

export const fetchWithTimeout = (input, init = {}, timeout = 30 * 1000) => new Promise((resolve, reject) => {
    const timeoutHandle = setTimeout(() => trackAndReject('timeout'), timeout);

    function trackAndResolve(response) {
        const globalLoginError = document.getElementById('global-login-error');
        const remoteFailure = response.headers.get('X-SimWorkflow-Error-Origin') === 'remote-service';
        if (!remoteFailure && [401, 403, 405].includes(response.status) && !globalLoginError) {
            const pageContent = document.querySelector('.ui.page-content');
            pageContent.insertAdjacentHTML('afterbegin', loginErrorMessage);
        } else if (!remoteFailure && ![401, 403, 405].includes(response.status) && globalLoginError) {
            globalLoginError.remove();
        }
        clearTimeout(timeoutHandle);
        resolve(response);
    }

    function trackAndReject(reason) {
        clearTimeout(timeoutHandle);
        reject(reason);
    }

    const csrf = {};
    const csrfHeaderName = document.querySelector('meta[name="swf-csrf-header-name"]')?.getAttribute('content');
    const csrfToken = document.querySelector('meta[name="swf-csrf-token"]')?.getAttribute('content');
    if (csrfHeaderName && csrfToken) {
        csrf[csrfHeaderName] = csrfToken;
    }

    fetch(input, {
        ...init,
        credentials: 'same-origin',
        headers: {
            ...init.headers || {},
            ...csrf
        }
    }).then(trackAndResolve, trackAndReject);
});

export const api = (input, init = {}) =>
    fetchWithTimeout(input, init)
        .then(response => {
            const contentType = response.headers.get('content-type');
            if (contentType?.includes('application/json')) {
                if (!response.ok) {
                    return response.json().then(json => {
                        return Promise.reject(json);
                    });
                }
                return response.json();
            } else {
                if (!response.ok) {
                    return response.text().then(text => {
                        return Promise.reject(text);
                    });
                }
                return response.text();
            }
        });
